import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OrderReservationService } from 'src/app/services/order-reservation.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { OrderReservationStatus } from 'src/app/enums/order-reservation-status.enum';
import { ProductService } from 'src/app/services/product.service';
import { switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-detail-order-reservation',
  templateUrl: './detail-order-reservation.component.html',
  styleUrls: ['./detail-order-reservation.component.scss']
})
export class DetailOrderReservationComponent {
  @Input() reservationDetail: any = null;
  @Input() reservationDetails: any[] = [];
  @Input() detailLoading: boolean = false;
  @Input() showModal: boolean = false;
  @Output() closed = new EventEmitter<boolean>();

  companyId: number = 1;

  statuses = OrderReservationStatus;
  
  statusOptions = [
    { key: 'RESERVED', label: OrderReservationStatus.RESERVED, color: 'bg-info' },
    { key: 'DONE', label: OrderReservationStatus.DONE, color: 'bg-success' },
    { key: 'TO_CONFIRMED', label: OrderReservationStatus.TO_CONFIRMED, color: 'bg-warning' },
    { key: 'EXPIRED', label: OrderReservationStatus.EXPIRED, color: 'bg-danger' },
    { key: 'CANCELLED', label: OrderReservationStatus.CANCELLED, color: 'bg-secondary' },
  ];

  constructor(
    private productService: ProductService,
    private toastr: ToastrService,
    private reservationService: OrderReservationService,
  ) {

  }

  close(modal: any) {
    this.closed.emit();
  }


  getReservationTotal(): number {
    if (!this.reservationDetails || this.reservationDetails.length === 0) return 0;
    return this.reservationDetails
      .map((d: any) => Number(d.quantity || 0) * Number(d.price || 0))
      .reduce((a: number, b: number) => a + b, 0);
  }

  toggleBreakdown(item: any) {
    item.showBreakdown = !item.showBreakdown;
    if (item.showBreakdown && !item.warehouseExistence) {
      this.loadWarehouseExistence(item);
    }
  }

  loadWarehouseExistence(item: any) {
    this.reservationService
          .getAllWarehouseExistence(
            item.productData.id
          )
      .subscribe({
        next: (response: ResponseObject) => {
          item.warehouseExistence = response.data
          .filter((w) => Number(w.existence) > 0)
          .map((w) => ({
            ...w,
            transferQuantity: 0
          }));
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error al cargar existencias del producto');
        }
      });
  }

  validateTransferQuantity(product: any, warehouse: any) {
    if (warehouse.transferQuantity > warehouse.existence) {
      this.toastr.warning('No puede pasar más de la existencia disponible.');
      warehouse.transferQuantity = warehouse.existence;
    }

    const totalAssigned = (product.warehouseExistence || [])
      .map((w: any) => Number(w.transferQuantity) || 0)
      .reduce((a: number, b: number) => a + b, 0);

    if (totalAssigned > product.quantity) {
      this.toastr.warning(
        `El producto "${product.productData?.name}" excede la cantidad reservada (${totalAssigned}/${product.quantity}).`
      );
    }
  }

  buildTransferRequest() {
    const request = {
      products: this.reservationDetails.map((item) => ({
        productId: item.productData?.id,
        totalQuantity: item.quantity,
        fromWarehouses:
          item.warehouseExistence
            ?.filter((w: any) => w.transferQuantity > 0)
            .map((w: any) => ({
              warehouseId: w.warehouseId,
              quantity: w.transferQuantity
            })) || []
      }))
    };
    return request;
  }

  getTotalTransferQuantity(item: any): number {
    if (!item.warehouseExistence) return 0;
    return item.warehouseExistence
      .map((w: any) => Number(w.transferQuantity) || 0)
      .reduce((a: number, b: number) => a + b, 0);
  }

  validateBeforeConfirm(): boolean {
    let valid = true;
    for (const prod of this.reservationDetails || []) {
      const totalAssigned = this.getTotalTransferQuantity(prod);
      const expected = Number(prod.quantity);

      if (totalAssigned > expected) {
        this.toastr.warning(
          `El producto "${prod.productData?.name}" excede la cantidad reservada (${totalAssigned}/${expected}).`
        );
        valid = false;
      }

      if (totalAssigned <= 0) {
        this.toastr.warning(
          `El producto "${prod.productData?.name}" no tiene cantidades asignadas para transferir.`
        );
        valid = false;
      }
    }
    
    return valid;
  }

  confirmTransfer() {
    if (!this.validateBeforeConfirm()) {
      this.toastr.error('Verifique las cantidades antes de continuar.');
      return;
    }

    const payload = this.buildTransferRequest();



    this.reservationService.transferProductValidation(this.reservationDetail.warehouseData?.id, new Date().toLocaleDateString('en-CA')).pipe(
      switchMap((validateRes: any) => {
        if(!validateRes.data){
          this.toastr.error('La Bodega no tiene Destino Asignado.');
          return throwError(() => new Error("No hay destino asignado para la transferencia, por favor asigne uno antes de realizar la transferencia"));
        } else {
          return this.reservationService.transferOrderReservation(this.reservationDetail.id, payload);
        }
      }),
    ).subscribe({
      next: (response) => {
        console.log(response);
        this.toastr.success('Transferencia realizada correctamente.')
        this.closed.emit(true);
      },
      error: (err) => this.toastr.error('Error al realizar la transferencia.')
    });

  }

  getStatusColor(status: string): string {
    const option = this.statusOptions.find(s => s.label === status);
    return option ? option.color : 'bg-secondary';
  }
}
